<!--
<div *ngFor="let extra of extras">
    <div *ngIf="!extra.multiple" class="form-group">
        <label>{{extra.description || extra.title}}</label>
        <select [ngModelOptions]="{standalone: true}" [(ngModel)]="extra.value" (ngModelChange)="extraChange(extra.title, $event)" class="form-control" required>
            <option *ngFor="let choice of extra.choices" [value]="choice[0]">{{choice[1]}}</option>
        </select>
    </div>
    <div *ngIf="extra.multiple" class="form-group">
        <label>{{extra.description || extra.title}}</label>
        <select multiple  [ngModelOptions]="{standalone: true}" [(ngModel)]="extra.value" (ngModelChange)="extraChange(extra.title, $event)" class="form-control" required>
            <option *ngFor="let extra_option of extra.choices" [value]="extra_option[0]">{{extra_option[1]}}</option>
        </select>
    </div>
</div>
-->
<form class="form-group">
<div *ngFor="let extra of extras" class="form-extra">
    <div *ngIf="!extra.multiple">
     <div class="form-extra-title">{{extra.description || extra.title}}</div>
        <div *ngFor="let choice of extra.choices">
        <input type="radio" class="form-check-input" (change)="extraChange(extra.title, $event)" [checked]="extra.value==choice[0]" [value]="choice[0]" [name]="extra.title">
        <label class="form-check-label">
            {{choice[1]}}
        </label>
        <div *ngIf="extra.feedback">
 <div class="alert {{choice[2]}}" role="alert" *ngIf="extra.value == choice[0]">{{choice[3]}}</div>
        </div>
       
        </div>
    </div>
    <div *ngIf="extra.multiple">
        <div class="form-extra-title">{{extra.description || extra.title}}</div>
        <div *ngFor="let choice of extra.choices">
        <input type="checkbox" class="form-check-input" (change)="extraChange(extra.title, $event)" [checked]="extra.value.indexOf(choice[0])>=0" [value]="choice[0]" [name]="extra.title">
        <label class="form-check-label" >
            {{choice[1]}}
        </label>
        </div>
    </div>
</div>
</form>